import { select, put, race, take } from 'redux-saga/effects';
import { commentsModel } from '../index';
import { CommentsFlow } from '../types';
import { RT } from '../../../../shared/types';

export function* watchPreviewStatus() {
  while (true) {
    const { payload } = yield take(commentsModel.actions.setCommentsFlow);

    if (payload !== CommentsFlow.Preview) {
      continue;
    }

    const { canceled, deleted, resoved } = yield race({
      canceled: take(commentsModel.actions.setCommentsFlow),
      deleted: take(commentsModel.actions.commentThreadDeleted),
      resoved: take(commentsModel.actions.commentThreadResolved),
    });

    if (canceled) {
      continue;
    }

    const threadId = (deleted || resoved)?.payload;

    if (!threadId) {
      continue;
    }

    const selectedThreadIds: RT<
      typeof commentsModel.selectors.selectSelectedThreadIds
    > = yield select(commentsModel.selectors.selectSelectedThreadIds);
    const updatedSelectedThreadIds = selectedThreadIds.filter(
      (id) => id !== threadId
    );

    yield put(
      commentsModel.actions.setSelectedThreads(updatedSelectedThreadIds)
    );

    if (updatedSelectedThreadIds.length === 0) {
      yield put(commentsModel.actions.setCommentsFlow(null));
    }
  }
}
